import script from "./ClassroomEarly.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomEarly.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomEarly.vue?vue&type=style&index=0&id=6cefd450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cefd450"]])

export default __exports__